/* import __COLOCATED_TEMPLATE__ from './submit-button.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './submit-button.module.scss';

export default class ContactSubmitButton extends Component {
  styles = styles;

  @service session;
}
